"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var _UserEmailPopup = require("./UserEmailPopup");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UserAdditionalEmails(_ref) {
  var tenantId = _ref.tenantId,
    hidden = _ref.hidden,
    additionalEmails = _ref.additionalEmails,
    onAddedEmail = _ref.onAddedEmail,
    onDeletedEmail = _ref.onDeletedEmail;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    emailPopup = _useState2[0],
    setEmailPopup = _useState2[1];
  if (!tenantId) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 3,
      display: hidden ? 'none' : 'block'
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    gutterBottom: true
  }, (0, _core.translate)('users.additional_emails.title')), /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_commons.Griddable, {
    items: additionalEmails,
    loading: false,
    empty: (0, _core.translate)('users.additional_emails.empty'),
    getId: function getId(email) {
      return email;
    },
    hoverable: false,
    noBorderLastRow: true,
    columns: [{
      title: (0, _core.translate)('users.email'),
      converter: function converter(email) {
        return email;
      },
      id: 'email',
      xs: true
    }, {
      title: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        color: "primary",
        size: "small",
        onClick: function onClick() {
          return setEmailPopup(true);
        }
      }, /*#__PURE__*/_react["default"].createElement(_commons.AddIcon, null)),
      converter: function converter(email, index, indexRow) {
        return /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          color: "error",
          size: "small",
          onClick: onDeletedEmail(indexRow)
        }, /*#__PURE__*/_react["default"].createElement(_commons.DeleteIcon, null));
      },
      id: 'actions',
      xs: 'auto',
      textAlign: 'center'
    }]
  })), emailPopup && /*#__PURE__*/_react["default"].createElement(_UserEmailPopup.UserEmailPopup, {
    onAdd: onAddedEmail,
    onClose: function onClose() {
      return setEmailPopup(false);
    }
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(UserAdditionalEmails);